module.exports = __webpack_public_path__ + "img/Lunar_Flare_demo.d996687b.gif";